import React from 'react'
import { connect } from 'react-redux'
import { Col, Container, Form, Row } from 'reactstrap'
import { getAllClubs } from '../../api/clubapi'
import { getBranches } from '../../api/productapi'
import PopupError from '../PopupError'
import { formatEditDate, formatInTimeZoneDateTime } from '../../helpers';
import PromoCode, { validator } from './PromoCode'
import * as Constants from '../../store/Constants'
import { getPromoCode, updatePromoCode, updateResponse } from '../../api/promoCodeApi'
import RequiredFieldNotation from '../utils/RequiredFieldNotation';

class PromoCodeEdit extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loaded: false,
            applyToCart: false,
            validation: validator().valid(),
            error: false,
            errorMessage: [],
            readOnly: true,
        }
    }

    componentDidMount() {
        if (this.props.branches.length === 0)
            this.props.getBranches(function (result, _this) { }, this)
        if (this.props.clubs.length === 0)
            this.props.getAllClubs(function (result, _this) { }, this, true)
        const promoCodeId = this.props.route.match.params.promoCodeId;
        this.props.getPromoCode(promoCodeId)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.promoCode !== this.props.promoCode && !this.state.loaded) {
            this.setState({
                loaded: true,
                ...this.props.promoCode,
                promoCodeProducts: this.props.promoCode.promoCodeProducts.map(x => ({ ...x })),
                applyToCart: this.props.promoCode.branchId === null,
            })
        }


        if (prevProps.updateResult !== this.props.updateResult && this.props.updateResult) {
            const { data } = this.props.updateResult
            if (data.success) {
                this.setState({ readOnly: true, loaded: false })
                this.submit = false
                this.props.getPromoCode(this.state.promoCodeId)
            } else {
                const errors = data.errors.map(e => e.message)
                this.setState({ error: true, errorMessage: errors })
            }
            this.props.updateResponse('')
        }
    }

    handleSubmit = e => {
        e.preventDefault()
        this.submit = true
        const startDate = document.getElementById("startDate") ? document.getElementById("startDate").value : this.state.startDate.substring(0, 10);
        const endDate = document.getElementById("endDate").value;
        this.setState({ startDate, endDate }, () => { this.updatePromoCode() })
    }

    updatePromoCode() {
        const validation = this.validate()
        if (validation.isValid) {
            const { ...promoCode } = this.state
            promoCode.clubId = +promoCode.clubId > 0 ? promoCode.clubId : null
            promoCode.branchId = +promoCode.branchId > 0 ? promoCode.branchId : null
            promoCode.assocPromoTypeCode = promoCode.assocPromoTypeCode !== Constants.promoTypeNone ? promoCode.assocPromoTypeCode : null
            promoCode.enrollFeePromoTypeCode = promoCode.enrollFeePromoTypeCode !== Constants.promoTypeNone ? promoCode.enrollFeePromoTypeCode : null
            promoCode.promoTypeCode = promoCode.promoTypeCode !== Constants.promoTypeNone ? promoCode.promoTypeCode : null
            promoCode.enrollFeePercentage = promoCode.enrollFeePromoTypeCode === Constants.promoTypeWaived ? promoCode.enrollFeeWaived : promoCode.enrollFeePercentage
            this.props.updatePromoCode(promoCode)
        }
    }

    validate = _ => {
        if (this.submit) {
            const validation = validator(this.state.applyToCart, this.state.promoTypeCode, this.state.enrollFeePromoTypeCode, this.state.assocPromoTypeCode).validate(this.state);
            this.setState({ validation });
            return validation
        } else {
            return { isValid: false }
        }
    }

    handleEdit = _ => {
        this.setState({ readOnly: false })
    }

    setSelectValue = (fieldKey, valueKey, fieldName, valueName) => this.setState({ [fieldKey]: valueKey, [fieldName]: valueName }, _ => this.validate())
    setFieldValue = (fieldName, value) => this.setState({ [fieldName]: value }, _ => this.validate())
    setPromoCodeProducts = value => this.setState({ promoCodeProducts: value.map(x => ({ productId: x })) }, _ => this.validate())
    setSourceProducts = (value) => {
        this.setState({ sourceProducts: value }, _ => this.validate())
    }
    setPromoTypeCode = (promoTypeCode) => {
        if (promoTypeCode === Constants.promoTypeFixedAmount)
            this.setState({ promoTypeCode, percentage: '', promoCodeNote: '' })
        else if (promoTypeCode === Constants.promoTypePercentage)
            this.setState({ promoTypeCode, fixedAmount: '', promoCodeNote: '' })
        else
            this.setState({ promoTypeCode, percentage: '', fixedAmount: '' })
    }
    setEnrollFeePromoTypeCode = (enrollFeePromoTypeCode) => {
        if (enrollFeePromoTypeCode === Constants.promoTypeFixedAmount) {
            this.setState({ enrollFeePromoTypeCode, enrollFeePercentage: '', enrollFeeWaived: '' }, _ => this.validate())
        }
        else if (enrollFeePromoTypeCode === Constants.promoTypePercentage) {
            this.setState({ enrollFeePromoTypeCode, enrollFeeFixedAmount: '', enrollFeeWaived: '' }, _ => this.validate())
        }
        else {
            this.setState({ enrollFeePromoTypeCode, enrollFeeWaived: '100', enrollFeePercentage: '', enrollFeeFixedAmount: '' }, _ => this.validate())
        }
    }
    setAssocPromoTypeCode = (assocPromoTypeCode) => {
        if (assocPromoTypeCode === Constants.promoTypeFixedAmount)
            this.setState({ assocPromoTypeCode, assocPercentage: '', assocFreeCount: '' })
        else if (assocPromoTypeCode === Constants.promoTypePercentage)
            this.setState({ assocPromoTypeCode, assocFixedAmount: '', assocFreeCount: '' })
        else
            this.setState({ assocPromoTypeCode, assocPercentage: '', assocFixedAmount: '', assocFreeCount: '1' })
    }
    updatePromoTypeSelected = (name, value) => {

        this.setState(
            (prev) => ({
                selectedPromoTypeCheckbox: value
                    ? prev.selectedPromoTypeCheckbox + 1
                    : prev.selectedPromoTypeCheckbox - 1
            })
        )
    }
    handleCancel = _ => {
        if (this.state.readOnly) {
            this.props.route.history.goBack()
        } else {
            this.submit = false
            this.setState({ readOnly: true, loaded: false, validation: validator().valid() })
            this.props.getPromoCode(this.state.promoCodeId)
        }
    }
    handleError = errors => this.setState({ error: true, errorMessage: errors })
    closeModal = () => this.setState({ error: false })

    render() {
        return <Container>
            <div className="card">
                <div className="card-header text-center">Edit Promo Code</div>

                {this.props.branches.length > 0
                    && this.props.clubs.length > 0
                    && this.state.loaded
                    && <div className="card-body fs-12">
                        <Form>
                            <RequiredFieldNotation />
                            <PromoCode
                                promoCodeCode={this.state.promoCodeCode}
                                promoCodeId={this.state.promoCodeId}
                                name={this.state.name}
                                clubId={this.state.clubId}
                                branchId={this.state.branchId}
                                setSelectValue={this.setSelectValue}
                                clubs={this.props.clubs}
                                branches={this.props.branches}
                                products={this.state.products}
                                branchIanaTimeZoneId={this.state.branchIanaTimeZoneId}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                isSingleUse={this.state.isSingleUse}
                                isPrimaryMembership={this.state.PromoTypeCode && this.state.PromoTypeCode !== Constants.promoTypeNone}
                                isEnrollmentFee={this.state.promoTypeCodeEnrollment && this.state.promoTypeCodeEnrollment !== Constants.promoTypeNone}
                                isAssociates={this.state.promoTypeCodeAssociates && this.state.promoTypeCodeAssociates !== Constants.promoTypeNone}
                                applyToPrimeMember={this.state.applyToPrimeMember}
                                applyToEnrollFee={this.state.applyToEnrollFee}
                                applyToAssoc={this.state.applyToAssoc}
                                promoTypeCode={this.state.promoTypeCode}
                                enrollFeePromoTypeCode={this.state.enrollFeePromoTypeCode}
                                assocPromoTypeCode={this.state.assocPromoTypeCode}
                                fixedAmount={this.state.fixedAmount}
                                percentage={this.state.percentage}
                                promoCodeNote={this.state.promoCodeNote}
                                enrollFeeFixedAmount={this.state.enrollFeeFixedAmount}
                                enrollFeePercentage={this.state.enrollFeePercentage}
                                enrollFeeWaived={this.state.enrollFeeWaived}
                                assocFixedAmount={this.state.assocFixedAmount}
                                assocPercentage={this.state.assocPercentage}
                                assocFreeCount={this.state.assocFreeCount}
                                readOnly={this.state.readOnly}
                                selectedPromoTypeCheckbox={this.state.selectedPromoTypeCheckbox}
                                sourceProducts={this.state.sourceProducts}
                                setFieldValue={this.setFieldValue}
                                setPromoTypeCode={this.setPromoTypeCode}
                                setEnrollFeePromoTypeCode={this.setEnrollFeePromoTypeCode}
                                setAssocPromoTypeCode={this.setAssocPromoTypeCode}
                                setPromoCodeProducts={this.setPromoCodeProducts}
                                setSourceProducts={this.setSourceProducts}
                                updatePromoTypeSelected={this.updatePromoTypeSelected}
                                validateSelectedProduct={this.validateSelectedProduct}
                                promoCodeProducts={this.state.promoCodeProducts}
                                validation={this.state.validation}
                                applyToCart={this.state.applyToCart}
                                promoCodeStatus={this.state.promoCodeStatus}
                                disableAssocPromo={this.state.disableAssocPromo}
                                disableAssocPromoByPrice={this.state.disableAssocPromoByPrice}
                                disableEnrollFeePromo={this.state.disableEnrollFeePromo}
                                handleCancel={this.handleCancel}
                                handleSubmit={this.handleSubmit}
                                handleError={this.handleError}
                                handleEdit={this.handleEdit} />
                        </Form>
                        <Col>
                            <hr />
                        </Col>
                        <Col>
                            <Row>
                                <div className="col-md-1">
                                    <div className="inline-label"><strong>ID</strong></div>
                                    <p className="editFooterText">{this.state.promoCodeId}</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="inline-label"><strong>Created by</strong></div>
                                    <p className="editFooterText">{this.state.createdBy}</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="inline-label"><strong>Created date</strong></div>
                                    <p className="editFooterText">{formatInTimeZoneDateTime(this.state.createdDate, this.state.branchIanaTimeZoneId)}</p>
                                </div>
                                <div className="col-md-2">
                                    <div className="inline-label"><strong>Updated by</strong></div>
                                    <p className="editFooterText">{this.state.updatedBy}</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="inline-label"><strong>Updated date</strong></div>
                                    <p className="editFooterText">{formatInTimeZoneDateTime(this.state.updatedDate, this.state.branchIanaTimeZoneId)}</p>
                                </div>
                            </Row>
                        </Col>
                    </div>}
                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage} />
            </div>
        </Container>
    }
}

export default connect(
    state => ({
        branches: state.data.branches,
        clubs: state.data.clubs,
        promoCode: state.data.promoCode,
        updateResult: state.data.updateResult,
        products: state.data.products
    }),
    dispatch => ({
        getBranches: (callback, context) => { dispatch(getBranches(callback, context)) },
        getAllClubs: (callback, context, onlyactive) => { dispatch(getAllClubs(callback, context, onlyactive)) },
        getPromoCode: (promoCodeId) => { dispatch(getPromoCode(promoCodeId)) },
        updatePromoCode: (promoCode) => { dispatch(updatePromoCode(promoCode)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
    })
)(PromoCodeEdit)